$(document).ready(function () {


    $(document).on("click", ".popup-close-btn", function (e) {
        e.preventDefault();
        $(this).closest(".wwr-popup").hide();
        $(this).closest(".wwr-popup").removeClass("show");
        if ($(this).closest(".wwr-popup").hasClass("video")) {
            $(this).closest(".wwr-popup").find("iframe").attr("src", "");
        }
    });
    $(document).on("click", ".wwr-popup", function (e) {
        e.preventDefault();
        $(this).hide();
        $(this).removeClass("show");

        if ($(this).hasClass("video")) {
            $(this).find("iframe").attr("src", "");
        }
    });
    $(document).on("click", ".wwr-popup .wrapper", function (e) {
        e.stopPropagation();
    });
    
    // setTimeout(() => {
    //     // e.preventDefault();
    //     $(".wwr-popup").show();
    //     $(".wwr-popup").addClass("show");
    // }, 3000);
});